module.exports = __webpack_public_path__ + "img/app-preview.5a457bde.png";